import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterByCreatedModal } from "../../../store/documentsSignerList";
import { selectCreatedByFilter } from "../../../store/documentsSignerList/selectors/selectCreatedByFilter";

export const FilterCreatedByChip = () => {
  const createdByFilter = useSelector(selectCreatedByFilter);
  const dispatch = useDispatch();
  return (
    <IonChip
      onClick={() => dispatch(setFilterByCreatedModal(true))}
      outline
      color={createdByFilter === "me" ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {createdByFilter === "all" && <span>Creado por: Todos</span>}
        {createdByFilter === "me" && (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Creado por: </span>
            Mí
          </IonText>
        )}
      </IonLabel>
    </IonChip>
  );
};
